import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBasicSanitationChartsDataContext } from './hooks/useBasicSanitationChartsDataContext';

export const SanitaryDrainage = () => {
    const { chartData } = useBasicSanitationChartsDataContext();

    return (
        <SimpleBars
            title={'Escotoamento Sanitário'}
            horizontal={true}
            subtitles={chartData?.sanitaryDrainage?.map((item) => item.description)}
            values={chartData?.sanitaryDrainage?.map((item) => item.total  ||  0)}
        />
    );
};
